// ── Service strukturált adat – egységes forma (2026-10-31) ──────────────────
//
// Minden Service node ugyanazt a vázat kapja, hogy a Google egyértelműen össze
// tudja kötni a vállalkozással és a két üzlettel:
//   - @id: <az oldal kanonikus URL-je>#service (egyedi, stabil),
//   - url: az oldal saját kanonikus URL-je,
//   - provider: a NorbiPhone Organization (@id hivatkozás),
//   - areaServed: a valós vonzáskörzet (constants/stores.js AREA_SERVED),
//   - availableChannel → serviceLocation: a két üzlet (@id hivatkozás). A
//     Szerviz oldal GYIK-ja szerint „Mindkét üzletünkben ugyanazokat a
//     szolgáltatásokat nyújtjuk” – ezért mindkét üzlet szerepel.
// A név/leírás/szolgáltatástípus az oldal saját szövegéből jön; itt nem
// találunk ki semmit.

import { BUSINESS, STORES, AREA_SERVED } from '../constants/stores';

export const SZOLGALTATAS_CSATORNA = {
  '@type': 'ServiceChannel',
  name: 'Személyes ügyintézés a NorbiPhone üzleteiben',
  serviceLocation: Object.values(STORES).map((s) => ({ '@id': s.schemaId })),
};

/** Egy Service node egységesítése az oldal kanonikus URL-jéhez.
 *  `sorszam` > 0: ugyanazon az oldalon a 2., 3. … Service (#service-2 …). */
export const egysegesService = (node, oldalUrl, sorszam = 0) => ({
  ...node,
  '@id': node['@id'] || `${oldalUrl}#service${sorszam ? `-${sorszam + 1}` : ''}`,
  url: node.url || oldalUrl,
  // Mindig a kanonikus Organization-re mutat (egyes oldalak korábban egy
  // névtelen, @id nélküli LocalBusiness-t adtak meg providerként).
  provider: { '@id': BUSINESS.id },
  areaServed: AREA_SERVED,
  availableChannel: node.availableChannel || SZOLGALTATAS_CSATORNA,
});

/** Az oldal JSON-LD node-jainak előkészítése a SEOHead számára:
 *   1. beágyazott @graph kilapítása (egyes oldalak a teljes buildPageGraph-ot
 *      adták át → a vállalkozás-node-ok kétszer kerültek a gráfba),
 *   2. a node-szintű @context eltávolítása,
 *   3. a Service node-ok egységesítése (lásd fent). */
export const oldalNodek = (schema, oldalUrl) => {
  const lista = (schema ? (Array.isArray(schema) ? schema : [schema]) : [])
    .filter(Boolean)
    .flatMap((n) => (n['@graph'] ? n['@graph'] : [n]))
    // a @graph-on belül a node-oknak nem kell saját @context (a gyökér adja)
    .map(({ '@context': _ctx, ...n }) => n);
  let s = 0;
  return lista.map((n) => (n['@type'] === 'Service' ? egysegesService(n, oldalUrl, s++) : n));
};

/** @id szerinti duplikátum-szűrés a kész gráfon (az első példány marad). */
export const egyediGraf = (graf) => {
  const lattam = new Set();
  return {
    ...graf,
    '@graph': graf['@graph'].filter((n) => {
      const id = n && n['@id'];
      if (!id) return true;
      if (lattam.has(id)) return false;
      lattam.add(id);
      return true;
    }),
  };
};
